<script setup lang="ts">
  import { computed, type Component } from 'vue';
  import { Sun, Moon, Monitor } from 'lucide-vue-next';
  import { useAppColorMode, type ColorModePreference } from '@/shared/lib/use';
  import Tooltip from '@/shared/ui/common/Tooltip.vue';

  interface ColorModeOption {
    icon: Component;
    label: string;
    hint: string;
  }

  const OPTIONS: Record<ColorModePreference, ColorModeOption> = {
    light: { icon: Sun, label: 'Tema claro', hint: 'Mudar para o tema escuro' },
    dark: { icon: Moon, label: 'Tema escuro', hint: 'Usar o tema do sistema' },
    auto: { icon: Monitor, label: 'Tema do sistema', hint: 'Mudar para o tema claro' },
  };

  const { preference, cycle } = useAppColorMode();

  const current = computed(() => OPTIONS[preference.value] ?? OPTIONS.light);
</script>

<template>
  <Tooltip
    :content="current.hint"
    placement="bottom"
  >
    <button
      type="button"
      class="flex h-11 w-11 items-center justify-center rounded-full border border-gray-02 text-gray-07"
      :aria-label="current.label"
      data-testid="color-mode-toggle"
      @click="cycle"
    >
      <component
        :is="current.icon"
        class="h-5 w-5"
        aria-hidden="true"
      />
    </button>
  </Tooltip>
</template>
